export const buildChartDatesForDayRange = (
  startDay: string | null,
  endDay: string | null,
): string[] => {
  if (startDay === null || endDay === null) return [];

  const start = new Date(`${startDay}T00:00:00.000Z`);
  const end = new Date(`${endDay}T23:59:59.999Z`);
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()) || start > end) return [];

  const dates: string[] = [];
  const cursor = new Date(start);
  cursor.setUTCHours(0, 0, 0, 0);
  const endCursor = new Date(end);
  endCursor.setUTCHours(0, 0, 0, 0);

  while (cursor <= endCursor) {
    dates.push(cursor.toISOString().slice(0, 10));
    cursor.setUTCDate(cursor.getUTCDate() + 1);
  }

  return dates;
};

export const resolveChartDates = (
  chartDates: string[],
  availableDates: Iterable<string>,
): string[] => {
  if (chartDates.length > 0) return chartDates;
  return Array.from(new Set(availableDates)).sort((left, right) => left.localeCompare(right));
};

type ResolveWindowDayKeysArgs = {
  startDay: string | null;
  endDay: string | null;
  fallbackStartDay?: string | null;
  fallbackEndDay?: string | null;
  descending?: boolean;
};

export const resolveWindowDayKeys = ({
  startDay,
  endDay,
  fallbackStartDay = null,
  fallbackEndDay = null,
  descending = false,
}: ResolveWindowDayKeysArgs): string[] => {
  const resolvedStartDay = startDay ?? fallbackStartDay;
  const resolvedEndDay = endDay ?? fallbackEndDay;
  const dayKeys = buildChartDatesForDayRange(resolvedStartDay, resolvedEndDay);

  return descending ? [...dayKeys].reverse() : dayKeys;
};
